<template>
  <div>
    <!-- 评论列表 -->
    <div
      class="cmt-list"
      :class="{
        'art-cmt-container-1': isShowCmtBox,
        'art-cmt-container-2': !isShowCmtBox,
      }"
    >

      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多评论了，请发表评论"
        @load="onLoad"
        :immediate-check="false"
      >
        <!-- 评论的 Item 项 -->
        <div class="cmt-item" v-for="obj in commentArr" :key="obj.com_id">
          <!-- 头部区域 -->
          <div class="cmt-header">
            <!-- 头部左侧 -->
            <div class="cmt-header-left">
              <img :src="obj.aut_photo" alt="" class="avatar" />
              <span class="uname">{{ obj.aut_name }}</span>
            </div>
            <!-- 头部右侧 -->
            <div class="cmt-header-right">
              <van-icon
                name="like"
                size="16"
                color="red"
                @click="likeFn(true, obj)"
                v-if="obj.is_liking === true"
              />
              <van-icon
                name="like-o"
                size="16"
                color="gray"
                @click="likeFn(false, obj)"
                v-else
              />
            </div>
          </div>
          <!-- 主体区域 -->
          <div class="cmt-body">
            {{ obj.content }}
          </div>
          <!-- 尾部区域 -->
          <div class="cmt-footer">{{ timeAgo(obj.pubdate) }}</div>
        </div>
      </van-list>
    </div>
    <!-- 发表评论的容器 -->
    <div>
      <!-- 底部添加评论区域 - 1 -->
      <div class="add-cmt-box van-hairline--top" v-if="isShowCmtBox === true">
        <van-icon name="arrow-left" size="0.48rem" @click="$router.back()" />
        <div class="ipt-cmt-div" @click="toggleShowFn">发表评论</div>
        <div class="icon-box">
          <van-badge :content="totalCount === 0 ? '' : totalCount" max="99">
            <van-icon
              name="comment-o"
              size="0.53333334rem"
              @click="commentClickFn"
            />
          </van-badge>
          <van-icon name="star-o" size="0.53333334rem" />
          <van-icon name="share-o" size="0.53333334rem" />
        </div>
      </div>

      <!-- 底部添加评论区域 - 2 -->
      <div class="cmt-box van-hairline--top" v-else>
        <textarea
          v-model.trim="comText"
          placeholder="友善评论、理性发言、阳光心灵"
          v-fofo
          @blur="blurFn"
        ></textarea>
        <van-button
          type="default"
          :disabled="comText.length === 0"
          @click="sendFn"
          >发布</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  commentsListAPI,
  commentLikingAPI,
  commentSendAPI,
  commentDisLikingAPI
} from '@/api'
import { timeAgo } from '@/utils/date.js'
export default {
  props: ['artObj'],
  data () {
    return {
      offset: null, // 偏移量评论ID
      commentArr: [], // 评论列表
      isShowCmtBox: true, // 底部显示短的还是搞得评论容器
      totalCount: 0, // 评论的总数量
      comText: '', // 关联发布评论的内容
      loading: false,
      finished: false,
      lastId: null // 分页
    }
  },
  async created () {
    const res = await commentsListAPI({
      id: this.$route.query.art_id // 文章id
    })
    this.commentArr = res.data.data.results
    this.totalCount = res.data.data.total_count
    this.lastId = res.data.data.last_id // 分页
  },
  methods: {
    timeAgo,
    // 点赞，取消点赞
    async likeFn (bool, commentObj) {
      if (bool === true) {
        // 用户点在了红心上，显示灰色的心
        commentObj.is_liking = false
        await commentDisLikingAPI({
          comId: commentObj.com_id
        })
      } else {
        // 用户点在了灰心上
        commentObj.is_liking = true
        await commentLikingAPI({
          comId: commentObj.com_id
        })
      }
    },
    toggleShowFn () {
      this.isShowCmtBox = false
    },
    commentClickFn () {
      // 只要设置window.scrollTo(0,文章内容高度)
      // artcile-container该盒子是在另外一个组件里，JS代码是在html+css运行后，真实DOM已经在网页上了，从document往下获取标签是可以的，不用传
      // const articleHeight = document.querySelector('.article-container').scrollHeight
      // window.scrollTo(0, articleHeight) // 此时可以位移但是没有移动
      // css可以做动画：列如轮播图，css位移，旋转动画（必须修改CSS属性才能触发CSS动画）
      // 使用anination(配合帧动画)，transition（过渡动画）
      // js也可以做动画：做滚动条滚动
      // 使用：计时器间隔时间，修改目标状态

      // html5新出原生标签.scrollIntoView(),让原生标签滚动到屏幕最上面
      // 为何选择like-box不选择第一条pinglun,因为头部导航会被挡住
      document.querySelector('.like-box').scrollIntoView({
        behavior: 'smooth'
      })
    },
    async sendFn () {
      // 将评论发布到列表里
      const res = await commentSendAPI({
        id: this.$route.query.art_id,
        content: this.comText
      })
      console.log(res)
      this.commentArr.unshift(res.data.data.new_obj) // 此时发布之后页面是不会刷新的，只是多了个标签
    },
    // 输入框失去焦点
    blurFn () {
      // 问题：点击发布按钮，发现点击事件不执行-排除代码问题
      // 原因： 高的评论容器-在页面点击发布一瞬间，输入框失去焦点
      // 被v-if v-else移除了整个标签，导致点击事件没来得及执行
      // 解决：失去焦点时，变量值，在最后执行
      setTimeout(() => {
        this.isShowCmtBox = true
      }, 0)
    },
    // 底部显示更多
    async onLoad () {
      if (this.commentArr.length > 0) {
        const res = await commentsListAPI({
          id: this.$route.query.art_id, // 文章id
          offset: this.lastId
        })
        this.commentArr = [...this.commentArr, ...res.data.data.results]
        this.totalCount = res.data.data.total_count
        this.lastId = res.data.data.last_id // 分页
        if (res.data.data.last_id === null) {
          this.finished = true
        }
        this.loading = false
      } else {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="less">
.cmt-list {
  padding: 10px;

  .cmt-item {
    padding: 15px 0;

    + .cmt-item {
      border-top: 1px solid #f8f8f8;
    }

    .cmt-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .cmt-header-left {
        display: flex;
        align-items: center;

        .avatar {
          width: 40px;
          height: 40px;
          background-color: #f8f8f8;
          border-radius: 50%;
          margin-right: 15px;
        }

        .uname {
          font-size: 12px;
        }
      }
    }

    .cmt-body {
      font-size: 14px;
      line-height: 28px;
      text-indent: 2em;
      margin-top: 6px;
      word-break: break-all;
    }

    .cmt-footer {
      font-size: 12px;
      color: gray;
      margin-top: 10px;
    }
  }
}

// 发表评论的样式
/*美化 - 文章详情 - 底部的评论页面 */
// 外层容器
.art-cmt-container-1 {
  padding-bottom: 46px;
}

.art-cmt-container-2 {
  padding-bottom: 80px;
}

// 发布评论的盒子 - 1
.add-cmt-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 46px;
  line-height: 46px;
  padding-left: 10px;

  .ipt-cmt-div {
    flex: 1;
    border: 1px solid #efefef;
    border-radius: 15px;
    height: 30px;
    font-size: 12px;
    line-height: 30px;
    padding-left: 15px;
    margin-left: 10px;
    background-color: #f8f8f8;
  }

  .icon-box {
    width: 40%;
    display: flex;
    justify-content: space-evenly;
    line-height: 0;
  }
}

.child {
  width: 20px;
  height: 20px;
  background: #f2f3f5;
}

// 发布评论的盒子 - 2
.cmt-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  padding-left: 10px;
  box-sizing: border-box;
  background-color: white;

  textarea {
    flex: 1;
    height: 66%;
    border: 1px solid #efefef;
    background-color: #f8f8f8;
    resize: none;
    border-radius: 6px;
    padding: 5px;
  }

  .van-button {
    height: 100%;
    border: none;
  }
}
</style>
